import React from 'react';
import { useHistory } from 'react-router-dom';
import './breadcrumb.scss';
import Breadcrumb from '../breadcrumb';
import Button from '../button';
import IconPrev from '../../../assets/images/icons/icons-chevron-left.svg';

export default function HeadingCenter({ children, pageConfig = {} }) {
  const history = useHistory();

  const onClickBackBtn = () => {
    const {
      location: { pathname },
    } = history;
    if (history.length && pathname !== '/') {
      history.goBack();
    }
  };

  return (
    <div className="breadcrumb">
      <Button className="ant-btn ant-btn-custom" onClick={onClickBackBtn}>
        <img src={IconPrev} alt="back icon" />
      </Button>
      <div className="detail-info">
        <Breadcrumb breadcrumb={pageConfig.breadcrumb} />
        <p className="more-info">{pageConfig.pageInfo}</p>
      </div>
      <div className="action-btn">{children}</div>
    </div>
  );
}
